import { IFormLayout } from '@/uikit/forms/NForm.vue';
import GroupWatchLists from './GroupWatchLists.vue';

const layout: IFormLayout = [
  {
    path: 'id',
    classes: 'n-form-w-6 form-pad',
    component: GroupWatchLists
  }
];

export default layout;
